// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1289":"76203479","4401":"2d0f74e8","7236":"76203479","7237":"76203479","9367":"76203479","9393":"63bea536"}[chunkId] + ".chunk.css";
};